export enum EventFieldVisibleRequiredEnum {
  Hidden = 0,
  RegistrationOnly = 1,
  AttendeeOnly = 2,
  BothRegistrationAndAttendee = 3,
}
